import React, { useState } from "react";
import { useNavigate } from "react-router";
import { IoPersonOutline, IoMailOutline, IoCallOutline, IoBusinessOutline } from "react-icons/io5";
import { AiOutlineLoading } from "react-icons/ai"; 
import NotificationsService from "../../rest/notificationService";
import logo from '../../resources/logo.png';
import LoginBackgroundMobile from '../../resources/bg_new_mobile.png';
import LoginBackground from '../../resources/bg_new.png';
import { toast } from "react-toastify";

const LeadForm = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        contactName: "",
        email: "",
        phone: "",
        company: "",
        notes: "",
    });

    const inputContainerStyle = "relative flex items-center mb-4";
    const iconStyle = "absolute left-3 text-gray-400 text-xl z-10";
    const inputStyleWithIcon = "w-full pl-10 pr-4 py-3 text-gray-700 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-custom_blue focus:ring-2 focus:ring-custom_blue/20 focus:outline-none transition-all duration-200 placeholder-gray-400";
    const textareaStyle = "w-full px-4 py-3 text-gray-700 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-custom_blue focus:ring-2 focus:ring-custom_blue/20 focus:outline-none transition-all duration-200 placeholder-gray-400 resize-none";

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (isLoading) return;
        setIsLoading(true);

        NotificationsService.sendLead(formData)
            .then(() => {
                toast.success("Recebemos seu contato! Em breve retornaremos.");
                setTimeout(() => {
                    navigate('/');
                }, 1000);
            })
            .catch((error) => {
                console.error(error);
                toast.error("Erro ao enviar. Por favor, tente novamente.");
                setIsLoading(false);
            });
    };

    return (
        <div className='relative min-h-screen w-full overflow-hidden font-sans bg-gray-900'>
            <div className="absolute inset-0 z-0">
                <img src={LoginBackgroundMobile} alt='cafeteria vertical background' className='absolute inset-0 object-cover w-full h-full blur-[3px] scale-105 block md:hidden' />
                <img src={LoginBackground} alt='cafeteria landscape background' className='absolute inset-0 object-cover w-full h-full blur-[3px] scale-105 hidden md:block' />
                <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/10 to-black/60"></div>
            </div>

            <div className='flex items-center justify-center min-h-screen relative z-10 p-4 py-12'>
                <div className='w-full max-w-md bg-white/95 sm:bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-8 sm:p-10 border border-white/20 transform transition-all'>

                    <div className="flex flex-col items-center mb-8">
                        <img src={logo} alt='Logo Foodz' className='w-40 h-auto object-contain mb-2 drop-shadow-sm' />
                        <h2 className="text-xl font-bold text-gray-800 mt-4 text-center">Fale Conosco</h2>
                        <p className="text-gray-500 text-sm text-center mt-2">Preencha os dados abaixo e entraremos em contato.</p>
                    </div>

                    <form onSubmit={handleSubmit} className='flex flex-col'>
                        <div className={inputContainerStyle}>
                            <IoPersonOutline className={iconStyle} />
                            <input type="text" name="contactName" value={formData.contactName} onChange={handleChange} required placeholder="Nome do contato *" className={inputStyleWithIcon} disabled={isLoading} />
                        </div>

                        <div className={inputContainerStyle}>
                            <IoMailOutline className={iconStyle} />
                            <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Email *" className={inputStyleWithIcon} disabled={isLoading} />
                        </div>

                        <div className={inputContainerStyle}>
                            <IoCallOutline className={iconStyle} />
                            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Telefone / WhatsApp" className={inputStyleWithIcon} disabled={isLoading} />
                        </div>

                        <div className={inputContainerStyle}>
                            <IoBusinessOutline className={iconStyle} />
                            <input type="text" name="company" value={formData.company} onChange={handleChange} required placeholder="Nome da Empresa/Escola *" className={inputStyleWithIcon} disabled={isLoading} />
                        </div>

                        <div className="mb-6 mt-2">
                            <label className="block text-sm font-medium text-gray-600 mb-2 ml-1">Observações (Opcional)</label>
                            <textarea name="notes" value={formData.notes} onChange={handleChange} placeholder="Dúvidas ou detalhes sobre sua necessidade..." rows={4} className={textareaStyle} disabled={isLoading} />
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className={`w-full py-3.5 rounded-xl bg-gradient-to-r from-custom_blue to-[#1e4585] shadow-lg shadow-custom_blue/30 font-bold tracking-wide text-white transition-all 
                            ${isLoading ? 'opacity-80 cursor-not-allowed' : 'hover:to-custom_blue transform active:scale-95'}`}
                        >
                            {isLoading ? (
                                <div className="flex items-center justify-center gap-2">
                                    <AiOutlineLoading className="animate-spin text-xl" />
                                    <span>ENVIANDO...</span>
                                </div>
                            ) : (
                                "ENVIAR SOLICITAÇÃO"
                            )}
                        </button>
                    </form>
                </div>

                <div className="absolute bottom-4 text-white/60 text-xs font-light tracking-wider text-center">
                    &copy; {new Date().getFullYear()} Foodz System.
                </div>
            </div>
        </div>
    );
};

export default LeadForm;